
import React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import Swipeout from 'rc-swipeout';
import { IESelect, IEInput, IETextArea, IEWidgetDateTimePicker, IEReactMultiSelectCluster } from "./InlineEdit/index"

import 'rc-swipeout/dist/rc-swipeout.css';
import '../assets/styles/Post.css'

@inject('videoForm')
@inject('videoStore')
@inject("clusterStore")
@observer
export default class Video extends React.Component {

    @observable showdetails = false;
    @observable clustervalue = [];

    @action
    showVideoDetail() {
        this.showdetails = !this.showdetails;
    }

    @action
    IEChangeState(field, newState) {
        let { videoStore, video } = this.props;
        console.log(newState);
        var value = newState.text;
        if (typeof (newState.value) !== 'undefined') {
            value = newState.value;
        }
        if (typeof (value) === 'undefined')
            throw new Error("Error getting new value of component for the video update");

        video[field] = value;
        videoStore.updateVideo(video);
    }

    @action
    switchVideoStatus() {
        let { videoStore, video } = this.props;

        if (video.status === 'close')
            video.status = 'open';
        else video.status = 'close';

        videoStore.updateVideo(video, false);
    }

    @action
    deleteVideo() {
        let { videoStore, video } = this.props;
        videoStore.deleteVideo(video);
    }

    @action
    handleSelectChange(newValue) {
        let { video } = this.props;
        video.clusters = newValue;
    }

    render() {
        let { videoForm, video, isLoggedIn } = this.props;                
        return (
            <Swipeout
                disabled={!isLoggedIn}
                left={[
                    {
                        text: 'Delete',
                        onPress: () => this.deleteVideo(),
                        className: 'delete-video'
                    }
                ]}>
                <div className={"post-content" + (this.showdetails ? " showdetails" : "")}>
                    <div className="post-heading">                        
                        <div className="post-title">
                            <IEInput
                                value={video.name}
                                change={(newState) => this.IEChangeState('name', newState)}
                                propName="text"
                                validate={(value) => { return videoForm.validateField('name', value) }}
                                classEditing="form-field-input"
                                classLoading="loading"
                                classInvalid="invalid" isDisabled={!this.showdetails} /></div>
                        {isLoggedIn &&
                            <div className="post-detail-toggle" onClick={() => this.showVideoDetail()}>
                                <div className={"post-detail-toggle " +
                                    (!this.showdetails ? "post-detail-toggle-open" : "post-detail-toggle-closed")}>{
                                        !this.showdetails
                                            ? <img alt="Edit" src={require("../assets/images/edit-button.png")} />
                                        : <img alt="End" src={require("../assets/images/button-close.svg")} />}</div>
                            </div>}
                    </div>                    
                    <div className="post-details videos">
                        {this.showdetails && <button className="post-detail-status-toggle delete-video" onClick={() => this.deleteVideo() }>Delete</button>}
                            <div className="post-detail-description">
                                <div className="post-detail-header">Video URL: </div>
                                <IETextArea value={video.url}
                                    change={(newState) => this.IEChangeState('url', newState)}
                                    propName="text"
                                    validate={(value) => { return videoForm.validateField('url', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} /></div>
                            <div className="post-detail-clusters">       
                                <span className="post-detail-header">Clusters: </span>                         
                                <IEReactMultiSelectCluster
                                    value={video.clusters}
                                    change={(newState) => this.IEChangeState('clusters', newState)}
                                    propName="value"
                                    validate={(value) => { return videoForm.validateField('clusters', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} />
                            </div>
                            <div className="post-detail-field"><span className="post-detail-header">Release: </span>
                                <IEWidgetDateTimePicker
                                    value={video.releasedate}
                                    change={(newState) => this.IEChangeState('releasedate', newState)}
                                    propName="value"
                                    validate={(value) => { return videoForm.validateField('releasedate', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} />
                            </div>
                            <div className="post-detail-field"><span className="post-detail-header">Expires: </span>
                                <IEWidgetDateTimePicker
                                    value={video.expirydate}
                                    change={(newState) => this.IEChangeState('expirydate', newState)}
                                    propName="value"
                                    validate={(value) => { return videoForm.validateField('expirydate', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} />
                            </div>    
                            <div className="post-detail-field video-options">
                                <span className="post-detail-header">Enabled: </span>
                                <IESelect value={video.enabled}
                                options={videoForm.$('enabled').extra}
                                    change={(newState) => this.IEChangeState('enabled', newState)}
                                    propName="value"
                                    validate={(value) => { return videoForm.validateField('enabled', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} />
                            </div>
                            <div className="post-detail-field video-options">
                                <span className="post-detail-header">Managers Only: </span>
                                <IESelect value={video.manageronly}
                                    options={videoForm.$('manageronly').extra}
                                    change={(newState) => this.IEChangeState('manageronly', newState)}
                                    propName="value"
                                    validate={(value) => { return videoForm.validateField('manageronly', value) }}
                                    classEditing="form-field-input"
                                    classLoading="loading"
                                    classInvalid="invalid" isDisabled={!this.showdetails} />
                            </div>
                        </div>
                </div>
            </Swipeout>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Video.jsx